var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDolphinSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 918.5 1285.5",
    style: {
      enableBackground: "new 0 0 918.5 1285.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007B93;}\n\t.st1{fill:#000026;}\n\t.st2{fill:#00DEF7;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#DEF1FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000103251081006576351780000006912068292246802575_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_layer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551.3,100c27.2-10.7,86.8-29.6,161.2-17.4c60.3,9.9,99.8,35.2,133.2,56.6c30.4,19.5,78.3,50.2,72.4,72.4 c-4.8,18.1-41.9,16.5-89,30.9c-57.2,17.4-101.8,50.2-136,84.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.3,354.2c-29.9,23.8-54.2,53.9-71.2,88.1c-18.9,38.1-22.4,69.1-25.3,95.3c-2.7,23.9-6.9,61.4,5.9,65.1 c10.5,3,24.2-19.1,49.4-41.9c30.6-27.7,63.5-43.2,93-52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,256.6c-0.5,1.8-30.6,114.2-94.9,145.2c-26.4,12.7-40.8,16.1-53.3,21.7c7.2-19,16.8-42.7,7.9-52.2 c-4.4-4.6-13-4.6-24.1-3.3c-10.2,1.2-9.8,3.1-22.7,3.9c10.7-1.8,21.1-5.6,65.7-15.1C179.4,342.2,231.1,258.2,232,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.8,937.2c49.8,19.6,81.5,42.2,120.3-2.5c53.2-61.4-110-490.5-208.9-519c-54.7-11.2-210.6,38.9-218.6,21.8 c-1.2-2.7,0.6-9.5,2.3-14.1c11.8-5.3,30.2-10.7,55.1-22.7c55.5-26.9,84-118.9,88.7-135.3c0.4-1.5,0.7-2.4,0.7-2.5 c-0.1,0.1-0.6,1.1-1.6,2.6c-9,14-54.3,80-112.7,92.5c-39.9,8.5-61.5,12.6-72.2,14.5l-1.7,0.3c-8.7,0.7-17.5,0.2-26.1-1.3 c-23.4-4.6-20.2-60.9,30.8-88.9l0.1-0.1c3.9-2.2,8-4.1,12.2-5.7c8.6-3.5,19.3-6,26.1-11.4c8.4-4.1,16.2-7,21.4-12.2 c17.5-17.5,33.7-96.3,33.7-96.3c5.1-13.8,10.4-27,16.8-38.6c0,0,123.8-215.4,375-64.5c401.5,241.2,55.2,865.2,34.5,919 c-20.7,53.8,56.7,176.1,21.2,255.8s-22.9,79.1-84.6-21.9s-74.5-89.9-58.6-151.6c-19.2,12.7-34.3,9.5-61.4-4.7 s-60.9-63.3-106.5-69.6S180.2,922,294,918.8C332.7,917.8,363.2,927.1,388.8,937.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348.3,156.4c0,3.7-0.4,7.3-1.1,10.9c-1.7-28.8-26.5-50.7-55.2-48.9c-28.8,1.7-50.7,26.5-48.9,55.2 c0.2,3.7,0.8,7.4,1.9,11c-15.6-26.4-6.8-60.5,19.6-76s60.5-6.8,76,19.6C345.6,136.7,348.3,146.5,348.3,156.4L348.3,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.2,167.3c-6,30.1-35.3,49.6-65.4,43.5c-15.5-3.1-28.9-12.6-36.9-26.2c-7.9-27.7,8.2-56.6,36-64.4 s56.6,8.2,64.4,36C346.3,159.8,347,163.5,347.2,167.3L347.2,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M577.9,824.3c-4.1,71.3-15.5,102.8-40.3,123.4c-25.4,21.1-62.3,28.7-93.8,21.4c-24.2-5.6-42.5-19.5-55-31.9 c49.8,19.6,81.5,42.2,120.3-2.5c53.2-61.4-110-490.5-208.9-519c-54.7-11.2-210.6,38.9-218.6,21.8c-1.2-2.7,0.6-9.5,2.3-14.1 c11.8-5.3,30.2-10.7,55.1-22.7c55.5-26.9,84-118.9,88.7-135.3c15.4-1.7,31-1.7,46.4-0.1c74.6,8.6,123.6,56.7,157.9,91.4 c64,64.7,91.8,132.5,108,173.3C587.9,650.4,582.4,746.3,577.9,824.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.1,394.6c-6,27,46.3,64.9,91.2,97.4c12.3,9,25.2,17.1,38.7,24.3c23.9,12.7,45.1,19.9,64.1,26.3 c26,8.8,66.9,22.7,71.9,10.1c4.1-10.3-19.1-30.3-42.2-62.7c-12.9-18.1-24.6-36.9-34.7-62.5c-12.3-31.2-7.6-37.8-15.4-48.8 C639.5,335.3,505.8,355.1,497.1,394.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolphinSvg);
export default __webpack_public_path__ + "static/media/DolphinSVG.0c8fd9e73228329d5266ec5b142bab61.svg";
export { ForwardRef as ReactComponent };